import { type FunctionComponent, } from "react"
import { useEscrowStore, } from "@stores/escrow";
import { usePointsStore, } from "@stores/points";
import moment from "moment";
import { n, } from "@helpers";
import { Button, useModalizeStore, } from "@components";
import { UnstakeAmount, } from "./UnstakeAmount";

import type { ExecutableToken, TokenInfo, } from "@types";
import "./UnstakeWarning.scss";



export declare type UnstakeWarningProps = {

};


export const UnstakeWarning: FunctionComponent<UnstakeWarningProps> = ({

}) => {

	const {
		balances,
		toUSD,
		withdrawInToken,
		season_conclude_date,
	} = useEscrowStore();

	const {
		user_points,
		early_deposit_boost,
		tvl_boost,
		size_boost,
	} = usePointsStore();

	const classes = () => [ `unstake-warning` ].join(" ");
	const pointsLost = () => {

		if(!withdrawInToken) throw new Error("UnstakeWarning::pointsLost was invoked without the withdrawIn token set.");
		const balance = balances[withdrawInToken.label as ExecutableToken];
		if(typeof balance !== "bigint") throw new Error("UnstakeWarning::pointsLost was invoked for a token which has no balance");

		const now = moment();
		const end = moment(season_conclude_date);
		const days = end.diff(now, "days");
		const dollars = toUSD(withdrawInToken, balance);


		const result3 = Math.ceil(
			days *
			n( dollars ) *
			( 1 + 
				( early_deposit_boost ) +
				( tvl_boost ) + 
				( size_boost )
			)
		);

		// console.log("EarlyDepositBoost%", ( early_deposit_boost - 1 ) * 100 + `%`);
		// console.log("result", result);
		return result3.toLocaleString();

	}

	if( withdrawInToken ) {
		return (
			<div className={classes()}>
				<p>By unstaking your {withdrawInToken.label} from Bracket, you will keep what you've earned so far, but here's what you would stack if you stay.</p>
				<div className="points-bar">
					<p>You would earn</p>
					<span className="earnings">{pointsLost()} points</span>
				</div>
			</div>
		);
	}
	throw new Error("UnstakeWarning View cannot perform without a token being set");

}
